"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.is-nan");
require("core-js/modules/es6.regexp.replace");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.number.constructor");
var _monthlyWelfare = require("@/api/basic/monthlyWelfare");
var _couponPackage = require("@/api/basic/couponPackage");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MonthlyWelfare',
  data: function data() {
    return {
      loading: false,
      saving: false,
      tableData: [],
      total: 0,
      searchForm: {
        page: 1,
        limit: 10,
        title: '',
        isEnable: null
      },
      editVisible: false,
      editForm: {
        id: null,
        title: '',
        userLevels: '',
        isEnable: 0,
        sort: 0,
        items: []
      },
      levelChecks: [],
      freePackages: [],
      rules: {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }]
      },
      joinVisible: false,
      joinLoading: false,
      joinList: [],
      joinTotal: 0,
      joinQuery: {
        page: 1,
        limit: 10,
        welfareId: null,
        mobile: '',
        userRank: null,
        status: null
      },
      resPath: process.env.VUE_APP_IMAGE_PATH || '',
      pkgSelectTip: '仅可选已启用、且售价方式为「按实际购买金额」的券包；售价方式由 CRM 同步'
    };
  },
  created: function created() {
    this.loadList();
    this.loadFreePackages();
  },
  methods: {
    loadList: function loadList() {
      var _this = this;
      this.loading = true;
      (0, _monthlyWelfare.getMonthlyWelfarePage)(this.searchForm).then(function (res) {
        var data = res && res.data || res || {};
        _this.tableData = data.list || [];
        _this.total = Number(data.total) || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    loadFreePackages: function loadFreePackages() {
      var _this2 = this;
      (0, _monthlyWelfare.getFreePackages)().then(function (res) {
        _this2.freePackages = res && res.data || res || [];
      }).catch(function () {
        _this2.freePackages = [];
      });
    },
    handleFilter: function handleFilter() {
      this.searchForm.page = 1;
      this.loadList();
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        page: 1,
        limit: 10,
        title: '',
        isEnable: null
      };
      this.loadList();
    },
    handleAdd: function handleAdd() {
      this.editForm = {
        id: null,
        title: '',
        userLevels: '',
        isEnable: 0,
        sort: 0,
        items: [{
          packageId: null,
          num: 1,
          alias: '',
          sort: 0,
          couponItems: []
        }]
      };
      this.levelChecks = [];
      this.editVisible = true;
    },
    handleEdit: function handleEdit(row) {
      var _this3 = this;
      (0, _monthlyWelfare.getMonthlyWelfareDetail)(row.id).then(function (res) {
        var data = res && res.data || res || {};
        _this3.editForm = {
          id: data.id,
          title: data.title,
          userLevels: data.userLevels || '',
          isEnable: data.isEnable != null ? data.isEnable : 0,
          sort: data.sort || 0,
          items: data.items && data.items.length ? data.items.map(function (it) {
            return {
              packageId: it.packageId,
              num: 1,
              alias: it.alias || '',
              sort: it.sort || 0,
              couponItems: []
            };
          }) : [{
            packageId: null,
            num: 1,
            alias: '',
            sort: 0,
            couponItems: []
          }]
        };
        _this3.levelChecks = (data.userLevels || '').split(',').map(function (s) {
          return s.trim();
        }).filter(Boolean);
        _this3.editVisible = true;
        _this3.editForm.items.forEach(function (item) {
          if (item.packageId) _this3._loadCouponItems(item);
        });
      });
    },
    addItem: function addItem() {
      this.editForm.items.push({
        packageId: null,
        num: 1,
        alias: '',
        sort: this.editForm.items.length,
        couponItems: []
      });
    },
    removeItem: function removeItem(idx) {
      this.editForm.items.splice(idx, 1);
    },
    /** 选中券包后回填别名并加载券明细 */onPackageChange: function onPackageChange(row) {
      if (!row || row.packageId == null) {
        this.$set(row, 'couponItems', []);
        return;
      }
      var pkg = (this.freePackages || []).find(function (p) {
        return p.id === row.packageId || String(p.id) === String(row.packageId);
      });
      if (pkg) {
        var alias = pkg.packageAlias && String(pkg.packageAlias).trim() || pkg.packageName && String(pkg.packageName).trim() || '';
        this.$set(row, 'alias', alias);
      }
      this._loadCouponItems(row);
    },
    _loadCouponItems: function _loadCouponItems(row) {
      var _this4 = this;
      if (!row || !row.packageId) {
        this.$set(row, 'couponItems', []);
        return;
      }
      (0, _couponPackage.getPackageWithItems)(row.packageId).then(function (res) {
        var pkg = res && res.data ? res.data : res || {};
        _this4.$set(row, 'couponItems', pkg.items || []);
      }).catch(function () {
        _this4.$set(row, 'couponItems', []);
      });
    },
    handleCouponImgUpload: function handleCouponImgUpload(_ref, row, ci) {
      var _this5 = this;
      var file = _ref.file;
      var fd = new FormData();
      fd.append('file', file);
      return (0, _couponPackage.uploadImage)(fd).then(function (res) {
        var path = res && res.data ? res.data : typeof res === 'string' ? res : '';
        if (!path) return;
        var coupon = row.couponItems[ci];
        if (!coupon) return;
        if (coupon.id) {
          (0, _couponPackage.updateCouponImg)({
            id: coupon.id,
            couponImgUrl: path
          }).catch(function (e) {
            _this5.$message.error('图片更新失败：' + (e && e.message || ''));
          });
        }
        _this5.$set(coupon, 'couponImgUrl', path);
      }).catch(function (e) {
        _this5.$message.error('上传失败：' + (e && e.message || ''));
      });
    },
    submitEdit: function submitEdit() {
      var _this6 = this;
      this.$refs.editForm.validate(function (valid) {
        if (!valid) return;
        if (!_this6.levelChecks.length) {
          _this6.$message.warning('请选择会员级别');
          return;
        }
        var items = (_this6.editForm.items || []).filter(function (i) {
          return i.packageId;
        });
        if (!items.length) {
          _this6.$message.warning('请至少选择一个券包');
          return;
        }
        var payload = _objectSpread(_objectSpread({}, _this6.editForm), {}, {
          userLevels: _this6.levelChecks.join(','),
          items: items.map(function (it, i) {
            return {
              packageId: it.packageId,
              num: 1,
              alias: it.alias,
              sort: it.sort != null ? it.sort : i
            };
          })
        });
        _this6.saving = true;
        (0, _monthlyWelfare.saveMonthlyWelfare)(payload).then(function () {
          _this6.$message.success('保存成功');
          _this6.editVisible = false;
          _this6.loadList();
        }).catch(function (e) {
          _this6.$message.error(e && e.message || '保存失败');
        }).finally(function () {
          _this6.saving = false;
        });
      });
    },
    handleToggle: function handleToggle(row) {
      var _this7 = this;
      var next = row.isEnable === 1 ? 0 : 1;
      (0, _monthlyWelfare.updateMonthlyWelfareStatus)({
        id: row.id,
        isEnable: next
      }).then(function () {
        _this7.$message.success('已更新');
        _this7.loadList();
      });
    },
    handleDelete: function handleDelete(row) {
      var _this8 = this;
      this.$confirm('确认删除该福利配置？', '提示', {
        type: 'warning'
      }).then(function () {
        return (0, _monthlyWelfare.deleteMonthlyWelfare)(row.id);
      }).then(function () {
        _this8.$message.success('已删除');
        _this8.loadList();
      }).catch(function () {
        // 取消确认 / 后端拦截（有领取记录时 request 层已提示「不可移除」）
      });
    },
    openJoin: function openJoin(row) {
      this.joinQuery = {
        page: 1,
        limit: 10,
        welfareId: row.id,
        mobile: '',
        userRank: null,
        status: null
      };
      this.joinVisible = true;
      this.loadJoin();
    },
    handleJoinSearch: function handleJoinSearch() {
      this.joinQuery.page = 1;
      this.loadJoin();
    },
    formatJoinUser: function formatJoinUser(row) {
      var mobile = row.mobilePhone || '-';
      var uid = row.userId != null ? row.userId : '-';
      var nick = row.nickName || '-';
      var rank = row.rankName || this.rankText(row.userRank);
      return "".concat(mobile, "(").concat(uid, ") (\u6635\u79F0: ").concat(nick, ")(\u7B49\u7EA7: ").concat(rank, ")");
    },
    rankText: function rankText(rank) {
      var map = {
        10: '普卡',
        20: '银卡',
        30: '金卡',
        40: '黑金卡',
        50: '钻石卡'
      };
      return map[rank] || (rank != null ? String(rank) : '-');
    },
    /** 列表里的 userLevels 是 10/20/30 编码，可逗号多选 */levelsText: function levelsText(userLevels) {
      var _this9 = this;
      if (userLevels == null || String(userLevels).trim() === '') return '-';
      return String(userLevels).split(',').map(function (s) {
        return s.trim();
      }).filter(Boolean).map(function (code) {
        return _this9.rankText(Number(code));
      }).join('、');
    },
    statusText: function statusText(status) {
      if (status === 1) return '领取成功';
      if (status === 0) return '领取中';
      if (status === 2) return '领取失败';
      return '-';
    },
    statusClass: function statusClass(status) {
      if (status === 1) return 'st-ok';
      if (status === 0) return 'st-ing';
      if (status === 2) return 'st-fail';
      return '';
    },
    formatJoinTime: function formatJoinTime(val) {
      if (!val) return '-';
      if (typeof val === 'string') return val.replace('T', ' ').substring(0, 19);
      var d = new Date(val);
      if (Number.isNaN(d.getTime())) return String(val);
      var p = function p(n) {
        return n < 10 ? '0' + n : '' + n;
      };
      return "".concat(d.getFullYear(), "-").concat(p(d.getMonth() + 1), "-").concat(p(d.getDate()), " ").concat(p(d.getHours()), ":").concat(p(d.getMinutes()), ":").concat(p(d.getSeconds()));
    },
    avatarUrl: function avatarUrl(path) {
      if (!path) return '';
      if (/^https?:\/\//i.test(path)) return path;
      return (this.resPath || '') + path;
    },
    loadJoin: function loadJoin() {
      var _this0 = this;
      this.joinLoading = true;
      var params = _objectSpread({}, this.joinQuery);
      if (params.mobile === '') delete params.mobile;
      if (params.userRank === null || params.userRank === '') delete params.userRank;
      if (params.status === null || params.status === '') delete params.status;
      (0, _monthlyWelfare.getMonthlyWelfareJoinPage)(params).then(function (res) {
        var data = res && res.data || res || {};
        _this0.joinList = data.list || [];
        _this0.joinTotal = Number(data.total) || 0;
      }).finally(function () {
        _this0.joinLoading = false;
      });
    }
  }
};